import styled from 'styled-components';

import { Title } from '../../ui/Title';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const OffersWrapper = styled.div`
  width: 90%;
  max-width: 1400px;
  min-width: 320px;
`;

export const PageTitle = styled(Title)`
  margin-top: 64px;
`;
